/* eslint no-console: 0 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(VueRouter)
Vue.use(ElementUI, { locale })

import App from 'views/auth-app.vue'
import Login from 'views/auth/login.vue'
import Registration from 'views/auth/registration.vue'
import PasswordReset from 'views/auth/password-reset.vue'

const router = new VueRouter({
  mode: 'history',
  base: '/auth/',
  routes: [
    { path: '/',          redirect: '/login' },
    { path: '/login',     name: 'login',          component: Login,         meta: { title: 'Sign in' } },
    { path: '/register',  name: 'registration',   component: Registration,  meta: { title: 'Register' } },
    { path: '/password',  name: 'reset_password', component: PasswordReset, meta: { title: 'Reset password' } }
  ]
})

import store from 'store'

import 'tachyons'
import 'element-ui/lib/theme-chalk/index.css'
import 'styles/setup.scss'

router.beforeEach((to, from, next) => {
  // If authenticated, abort and redirect to app
  if (store.getters['auth/isAuthenticated']) {
    window.location.assign('/app')
    return false;
  }

  // Find neatest route with title and set document title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  document.title = nearestWithTitle ? nearestWithTitle.meta.title + ' / Metsis' : 'Metsis';
  
  // Continue
  next()
});

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
  })
})
